import { actionTypes } from "../actions/reports";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_REPORTS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;